import type { ICity, ICountry, IExcelEmployeeTemplate, IIntegration, IType } from '@/types/Data'
import type { IExcelImportEmployee, IExcelInsertEmployee } from '@/types/Request'
import { JsonToFormData } from '@/utils-ts'
import BaseService from '../BaseService'

export default class CommonServices extends BaseService {
  GetCountryList() {
    return this.GET<ICountry[]>(this.PATHS.GET_COUNTRY_LIST)
  }

  GetCityList(CountryId: string | null = null) {
    return this.GET<ICity[]>(this.PATHS.GET_CITY_LIST, { CountryId })
  }

  GetTypeList(ParentId: string) {
    return this.GET<IType[]>(this.PATHS.GET_TYPE_LIST, { ParentId })
  }

  RemoveCache(CompanyId: string) {
    return this.GET<void>(this.PATHS.REMOVE_CACHE, { CompanyId })
  }

  ReIndexElasticSearchEmployees(companyId: string) {
    return this.GET<void>(this.PATHS.RE_INDEX_ELASTIC_SEARCH_EMPLOYEES, { companyId })
  }

  ReIndexElasticSearchPosts(companyId: string) {
    return this.GET<void>(this.PATHS.RE_INDEX_ELASTIC_SEARCH_POSTS, { companyId })
  }

  GetIntegrationList() {
    return this.GET<IIntegration[]>(this.PATHS.GET_INTEGRATION_LIST)
  }

  RemoveIntegration(appId: string) {
    return this.DELETE<void>(this.PATHS.REMOVE_INTEGRATION, { appId })
  }

  ExcelImportEmployee(data: IExcelImportEmployee) {
    return this.POST<IExcelEmployeeTemplate[]>(
      this.PATHS.EXCEL_IMPORT_EMPLOYEE,
      JsonToFormData(data),
    )
  }

  ExcelInsertEmployee(data: IExcelInsertEmployee) {
    return this.POST<IExcelEmployeeTemplate[]>(this.PATHS.EXCEL_INSERT_EMPLOYEE, data)
  }
}
